import { Injectable } from '@angular/core';
import {HttpObservable, HttpWrapper} from '../../http-helpers/http.wrapper';

@Injectable({
  providedIn: 'root'
})
export class TranslateProxy {

  constructor(private httpWrapper: HttpWrapper) { }

  public getPreLoginTranslations(): HttpObservable<object> {
    return this.httpWrapper.getAnon('PatientPortalTranslate', 'GetPreLoginTranslations');
  }

  public getLookupDataTranslation(langKey: number, key: string[]): HttpObservable<string[]> {
    return this.httpWrapper.getAnon('PatientPortalTranslate', 'GetLookupDataTranslation', [
      {pName: 'langKey', pVal: langKey},
      {pName: 'keys', pVal: key}
      ]);
  }

  public getTranslation(lang: string): HttpObservable<object> {
    return this.httpWrapper.getAnon('PatientPortalTranslate', 'GetTranslation', {pName: 'lang', pVal: lang});
  }
}
